import { Component }                from '@angular/core';
import { DomSanitizer, SafeHtml }   from '@angular/platform-browser';
import { DashboardHtml }            from '../../models/dashboard-html';
import { IDashboardPanelComponent } from '../../models/i-dashboard-panel-component';
import { ArrayUtils }               from '@cs/core';

@Component({
	selector:    'cs-dashboard-html',
	templateUrl: './dashboard-html.component.html'
})
export class DashboardHtmlComponent implements IDashboardPanelComponent<DashboardHtml> {

	name: string;

	set data(value: DashboardHtml) {
		this._data = value;
		this.setData();
	}

	/**
	 * The data source that contains the values of the statistics panel.
	 */
	private _data: DashboardHtml;

	safeHtml: SafeHtml;

	constructor(private sanitizer: DomSanitizer) {
	}

	setData(): void {
		this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this._data.html);
	}

	update(data: DashboardHtml): void {

		if (this.data && ArrayUtils.isEqual(this.data, data))
			return;

		this.data = data;
		this.setData();
	}
}
